import { TOOLS_IDS } from './constants';
import fitTextAnnotationToContent from './fitTextAnnotationToContent';
import randomId from './randomId';

/**
 * Builds a centered plain-text layer for Draw → Text (click-to-add, no drag box).
 */
const buildDefaultTextAnnotation = ({
  config = {},
  shownImageDimensions = {},
  adjustments = {},
} = {}) => {
  const crop = adjustments.crop || {};
  const layerWidth = crop.width || shownImageDimensions.width || 400;
  const layerHeight = crop.height || shownImageDimensions.height || 300;
  const layerCropX = crop.x || 0;
  const layerCropY = crop.y || 0;
  const textConfig = config[TOOLS_IDS.TEXT] || {};

  const baseAnnotation = {
    ...config.annotationsCommon,
    ...textConfig,
    id: randomId(TOOLS_IDS.TEXT),
    name: TOOLS_IDS.TEXT,
    x: 0,
    y: 0,
  };

  const fitted =
    fitTextAnnotationToContent(baseAnnotation) || baseAnnotation;
  const width = fitted.width || 120;
  const height = fitted.height || 40;

  return {
    ...fitted,
    x: layerCropX + Math.max(0, (layerWidth - width) / 2),
    y: layerCropY + Math.max(0, (layerHeight - height) / 2),
    width,
    height,
  };
};

export default buildDefaultTextAnnotation;
